document.addEventListener("DOMContentLoaded", () => {
  const getSlideImageUrl = (slide) => {
    const img = slide?.querySelector("img");
    if (!img) return "";
    return img.getAttribute("data-src") || img.currentSrc || img.src || "";
  };

  const getBgIndexForMain = (mainIndex, slideCount) =>
    Math.max(0, slideCount - 1 - mainIndex);

  const slideBgToIndex = (bgSwiper, index, speed, loopEnabled) => {
    if (loopEnabled && typeof bgSwiper.slideToLoop === "function") {
      bgSwiper.slideToLoop(index, speed, false);
      return;
    }
    bgSwiper.slideTo(index, speed, false);
  };

  const syncBgToMain = (bgSwiper, mainSwiper, slideCount, speed = 0, loopEnabled = true) => {
    const targetBgIndex = getBgIndexForMain(mainSwiper.realIndex, slideCount);
    if (bgSwiper.realIndex === targetBgIndex) return;
    slideBgToIndex(bgSwiper, targetBgIndex, speed, loopEnabled);
  };

  document.querySelectorAll(".em-slider-container").forEach((container) => {
    const bgEl = container.querySelector(".bg-swiper");
    const mainEl = container.querySelector(".main-swiper");
    if (!bgEl || !mainEl) return;

    const bgWrapper = bgEl.querySelector(".swiper-wrapper");
    const mainWrapper = mainEl.querySelector(".swiper-wrapper");
    if (!bgWrapper || !mainWrapper) return;

    const bgSlides = Array.from(bgWrapper.children);
    const mainSlides = Array.from(mainWrapper.children);
    const slideCount = mainSlides.length;
    if (!slideCount) return;

    const mainSlideUrls = mainSlides.map(getSlideImageUrl);
    const reversedUrls = mainSlideUrls.slice().reverse();

    bgSlides.sort((a, b) => {
      const aUrl = getSlideImageUrl(a);
      const bUrl = getSlideImageUrl(b);
      return reversedUrls.indexOf(aUrl) - reversedUrls.indexOf(bUrl);
    });
    bgSlides.forEach((slide) => bgWrapper.appendChild(slide));

    const loopEnabled = slideCount > 1;
    const loopOptions = loopEnabled
      ? { loop: true, loopedSlides: slideCount }
      : { loop: false };

    const bgSwiper = new Swiper(bgEl, {
      ...loopOptions,
      speed: 1800,
      allowTouchMove: false,
      parallax: true,
      watchSlidesProgress: true,
    });

    const mainSwiper = new Swiper(mainEl, {
      ...loopOptions,
      speed: 1800,
      parallax: true,
      watchSlidesProgress: true,
      autoplay: loopEnabled
        ? {
            delay: 3000,
            disableOnInteraction: false,
          }
        : false,
    });

    syncBgToMain(bgSwiper, mainSwiper, slideCount, 0, loopEnabled);

    mainSwiper.on("slideNextTransitionStart", () => {
      bgSwiper.slidePrev(1800, false);
    });

    mainSwiper.on("slidePrevTransitionStart", () => {
      bgSwiper.slideNext(1800, false);
    });

    mainSwiper.on("slideChangeTransitionEnd", () => {
      syncBgToMain(bgSwiper, mainSwiper, slideCount, 0, loopEnabled);
    });

    const paginationContainer = container.querySelector(".em-custom-pagination");
    if (!paginationContainer) return;

    const paginationBullets = paginationContainer.querySelectorAll(".pagination-bullet");

    mainSwiper.on("slideChange", () => {
      const activeIndex = mainSwiper.realIndex;
      paginationBullets.forEach((bullet, index) => {
        bullet.classList.toggle("active", index === activeIndex);
      });
    });

    paginationBullets.forEach((bullet, index) => {
      bullet.addEventListener("click", () => {
        if (loopEnabled) {
          mainSwiper.slideToLoop(index);
        } else {
          mainSwiper.slideTo(index);
        }
        slideBgToIndex(
          bgSwiper,
          getBgIndexForMain(index, slideCount),
          1800,
          loopEnabled
        );
      });
    });
  });
});


// ===============================
// Mobile: full-page per-section navigation for em-slider-stack
// ===============================
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth > 768) return;

    const containers = Array.from(document.querySelectorAll('.em-slider-container'));
    if (!containers.length) return;

    let currentIndex = 0;
    let isTransitioning = false;
    let touchStartY = 0;

    // Keep currentIndex in sync with whichever section is most visible
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const idx = containers.indexOf(entry.target);
          if (idx !== -1) currentIndex = idx;
        }
      });
    }, { threshold: 0.5 });

    containers.forEach(c => observer.observe(c));

    const goToSection = (index) => {
      if (isTransitioning || index < 0 || index >= containers.length) return;
      isTransitioning = true;
      currentIndex = index;

      if (window.lenis) {
        window.lenis.scrollTo(containers[index], { duration: 0.8 });
      } else {
        containers[index].scrollIntoView({ behavior: 'smooth' });
      }

      setTimeout(() => { isTransitioning = false; }, 950);
    };

    document.addEventListener('touchstart', e => {
      const stack = document.querySelector('.em-slider-stack');
      if (stack && stack.contains(e.target)) {
        touchStartY = e.touches[0].clientY;
      }
    }, { passive: true });

    document.addEventListener('touchend', e => {
      const stack = document.querySelector('.em-slider-stack');
      if (!stack || !stack.contains(e.target)) return;

      const deltaY = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(deltaY) < 50) return;

      if (deltaY > 0) goToSection(currentIndex + 1);
      else goToSection(currentIndex - 1);
    }, { passive: true });
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  const awardsSlider = document.querySelector('.exp-awards-slider');
  if (!awardsSlider) return;

  new Splide(awardsSlider, {
    type       : 'loop',
    perPage    : 3,
    gap        : '95px',
    arrows     : false,
    pagination : false,
    drag       : false,
    autoplay   : false,
    breakpoints: {
      992: { 
        perPage: 2, 
        gap: '1rem', 
        drag: true, 
        autoplay: true,  
        speed: 1000,
        interval: 3000 
      },
      576: { 
        perPage: 1, 
        gap: '0.5rem', 
        drag: true, 
        autoplay: true,  
        speed: 1000,
        interval: 3000,
        fixedWidth: '70%',
        fixedHeight: false,
        focus: 'center'
      }
    }
  }).mount();
});

// ===============================
// Experience Content Text Animation (mirrors homepage stone curation)
// ===============================
document.addEventListener('DOMContentLoaded', function () {
  const contentContainer = document.querySelector('.em-content-block');
  if (!contentContainer) return;

  const textElements = contentContainer.querySelectorAll('h3, p');

  // Prepare words for animation (desktop and mobile; section2Activated fires when section2 is in view on mobile)
  textElements.forEach(el => {
    const words = el.textContent
      .trim()
      .split(/\s+/)
      .map(word => `<span class="word">${word}&nbsp;</span>`)
      .join('');
    el.innerHTML = words;
  });

  const words = gsap.utils.toArray('.em-content-block .word');

  gsap.set(words, {
    yPercent: 100,
    opacity: 0
  });

  // Animate when the transition wrapper finishes and section 2 activates
  let hasPlayed = false;
  const playTextAnimation = () => {
    if (hasPlayed) return;
    hasPlayed = true;
    contentContainer.classList.add('show-content');
    gsap.to(words, {
      yPercent: 0,
      opacity: 1,
      duration: 0.6,
      ease: 'power2.out',
      stagger: 0.05
    });
  };

  const resetTextAnimation = () => {
    hasPlayed = false;
    contentContainer.classList.remove('show-content');
    gsap.set(words, {
      yPercent: 100,
      opacity: 0
    });
  };

  // Custom event dispatched by transition timeline in about.js for experience page
  document.addEventListener('section2Activated', playTextAnimation);
  document.addEventListener('experienceSection2ReverseStart', resetTextAnimation);
});

document.addEventListener('DOMContentLoaded', function () {
  const getStickyHeaderOffset = () => {
    const header = document.querySelector('#header, .site-header, .main-header, header');
    if (!header) return 0;

    const rect = header.getBoundingClientRect();
    // If header is translated/hidden above viewport, don't reserve offset.
    if (rect.bottom <= 0 || rect.height <= 0) return 0;

    const computedStyle = window.getComputedStyle(header);
    const isFixedHeader = computedStyle.position === 'fixed' || computedStyle.position === 'sticky';
    if (!isFixedHeader) return 0;

    return Math.ceil(rect.height || 0);
  };

  const scrollToElementWithOffset = (target, options = {}) => {
    const immediate = !!options.immediate;
    const headerOffset = getStickyHeaderOffset();
    const targetY = target.getBoundingClientRect().top + window.scrollY - headerOffset;

    if (window.lenis && typeof window.lenis.scrollTo === 'function') {
      window.lenis.scrollTo(Math.max(targetY, 0), immediate ? { immediate: true } : { duration: 1.2 });
      return;
    }

    window.scrollTo({
      top: Math.max(targetY, 0),
      behavior: immediate ? 'auto' : 'smooth',
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-scroll-target]');
    if (!trigger) return;

    const targetId = trigger.getAttribute('data-scroll-target');
    if (!targetId) return;

    const target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();
    if (targetId === 'book-a-visit') {
      const transitionWrapper = document.querySelector('.experience-transition-wrapper');
      const section1 = transitionWrapper ? transitionWrapper.querySelector('#section1') : null;
      const section2 = transitionWrapper ? transitionWrapper.querySelector('#section2') : null;

      if (transitionWrapper) transitionWrapper.classList.add('section2-pin-active');
      if (section1) section1.classList.remove('section--active');
      if (section2) section2.classList.add('section--active');
      document.body.classList.add('section2-active');

      if (window.lenis && typeof window.lenis.start === 'function') {
        window.lenis.start();
        if (typeof window.lenis.resize === 'function') {
          window.lenis.resize();
        }
      }

      document.dispatchEvent(new CustomEvent('section2Activated'));
    }

    // Let section state/layout settle before measuring final target position.
    requestAnimationFrame(() => {
      scrollToElementWithOffset(target);
      // One more correction after layout/height changes complete.
      setTimeout(() => {
        scrollToElementWithOffset(target, { immediate: true });
      }, 450);
    });
  });

  const creationSlider = document.querySelector('.exp-mci-creation-slider');
  if (!creationSlider) return;

  const creationSplide = new Splide(creationSlider, {
    type: 'loop',
    padding: '20%',
    autoplay: true,
    interval: 3000,
    pauseOnHover: false,
    pauseOnFocus: true,
    speed: 1200,
    arrows: false,
    pagination: true,
    breakpoints: {
      768: {
        perPage: 1,
        padding: '8%',
      },
    },
  });

  creationSplide.mount();

  const watchButtons = creationSlider.querySelectorAll('.video-trigger');
  watchButtons.forEach((button) => {
    button.addEventListener('mouseenter', () => {
      creationSplide.Components.Autoplay.pause();
    });
    button.addEventListener('mouseleave', () => {
      creationSplide.Components.Autoplay.play();
    });
  });
});




